import { showClearConfirmationModal } from '../ui/modals/clearConfirmation';
import { showShortcutsModal } from '../ui/modals/shortcutsModal';
import type { ExportController } from './ExportController';
import type { AppMode } from '../types';
import { STORAGE_KEYS } from '../config/storageKeys';

export type ViewportToolbarCanvas = {
  zoomIn: () => void;
  zoomOut: () => void;
  resetView: () => void;
  setPanMode: (enabled: boolean) => void;
  setGridEnabled: (enabled: boolean) => void;
  setSnapEnabled: (enabled: boolean) => void;
  setInverted: (enabled: boolean) => void;
};

export type ViewportToolbarCallbacks = {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onResetView: () => void;
  onPanModeChange: (enabled: boolean) => void;
  onGridToggle: (enabled: boolean) => void;
  onSnapToggle: (enabled: boolean) => void;
  onInvertToggle: (enabled: boolean) => void;
  onShowShortcuts: () => void;
  onExport: () => void;
};

export interface ViewportToolbarContext {
  getCanvas: () => ViewportToolbarCanvas | null;
  getMode: () => AppMode;
  getExportController: () => ExportController | null;
}

export function buildViewportToolbarCallbacks(
  context: ViewportToolbarContext
): ViewportToolbarCallbacks {
  const handleZoomIn = (): void => {
    context.getCanvas()?.zoomIn();
  };
  const handleZoomOut = (): void => {
    context.getCanvas()?.zoomOut();
  };
  const handleResetView = (): void => {
    context.getCanvas()?.resetView();
  };
  const handlePanModeChange = (enabled: boolean): void => {
    context.getCanvas()?.setPanMode(enabled);
  };
  const handleGridToggle = (enabled: boolean): void => {
    context.getCanvas()?.setGridEnabled(enabled);
  };
  const handleSnapToggle = (enabled: boolean): void => {
    context.getCanvas()?.setSnapEnabled(enabled);
  };
  const handleInvertToggle = (enabled: boolean): void => {
    context.getCanvas()?.setInverted(enabled);
  };
  const handleShowShortcuts = (): void => {
    showShortcutsModal(context.getMode());
  };
  const handleExport = (): void => {
    context.getExportController()?.openExportModal();
  };

  return {
    onZoomIn: handleZoomIn,
    onZoomOut: handleZoomOut,
    onResetView: handleResetView,
    onPanModeChange: handlePanModeChange,
    onGridToggle: handleGridToggle,
    onSnapToggle: handleSnapToggle,
    onInvertToggle: handleInvertToggle,
    onShowShortcuts: handleShowShortcuts,
    onExport: handleExport,
  };
}

export function confirmClear(onConfirm: () => void): void {
  showClearConfirmationModal({
    skipKey: STORAGE_KEYS.skipClearConfirm,
    onConfirm,
  });
}
